import { render, staticRenderFns } from "./OpportunitiesList.vue?vue&type=template&id=e02e71dc&scoped=true"
import script from "./OpportunitiesList.vue?vue&type=script&lang=js"
export * from "./OpportunitiesList.vue?vue&type=script&lang=js"
import style0 from "./OpportunitiesList.vue?vue&type=style&index=0&id=e02e71dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02e71dc",
  null
  
)

export default component.exports